import React from 'react';
import { motion } from 'framer-motion';
import "./Testimonial.css"

const Testimonial = () => {
    return (
        <div className="container py-5 ">
            <motion.h2 
                className="text-center text-primary fw-bold mb-4 "
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                What Our Students Say
            </motion.h2>
            
            <div id="testimonialCarousel" className="carousel slide shadow-lg rounded-4 overflow-hidden" data-bs-ride="carousel">
                <div className="carousel-inner bg-white p-5 rounded-4">
                    <div className="carousel-item active text-center">
                        <motion.div 
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <p className="fs-5 fst-italic text-muted">
                                "Prakash Institute’s coaching helped me clear IIT-JEE with a great rank. The faculty and resources are amazing!"
                            </p>
                            <p className="fw-bold text-dark">Amit Kumar</p>
                        </motion.div>
                    </div>
                    <div className="carousel-item text-center">
                        <motion.div 
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <p className="fs-5 fst-italic text-muted">
                                "Thanks to Prakash Institute, I cracked NEET with ease. The personal attention and mock tests were very helpful."
                            </p>
                            <p className="fw-bold text-dark">Neha Sharma</p>
                        </motion.div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon bg-dark rounded-circle p-2" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon bg-dark rounded-circle p-2" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}

export default Testimonial;
